import { render, staticRenderFns } from "./ClaimRequestDetails.vue?vue&type=template&id=72b39e6b&"
import script from "./ClaimRequestDetails.vue?vue&type=script&lang=js&"
export * from "./ClaimRequestDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClaimRequestDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports